<template>
  <ApplicationLayoutDefault>
    <div class="register-new">
      <div id="content">
        <div class="register">
          <div class="wrapper">
            <div class="inner">
              <div class="main">
                <h1 class="main-title">Candidate Registration</h1>
                <div class="register-link">
                  <a href="/recruiter_applications/new"
                    >Recruiter Registration</a
                  >
                </div>
                <Form>
                  <validation-observer ref="form" v-slot="{ invalid }">
                    <sui-form
                      autocomplete="off"
                      enctype="multipart/form-data"
                      action="/talents/confirm"
                      accept-charset="UTF-8"
                      method="post"
                    >
                      <input
                        type="hidden"
                        name="authenticity_token"
                        :value="csrfToken"
                      />
                      <div class="list">
                        <validation-provider
                          v-slot="{ errors }"
                          vid="name"
                          slim="slim"
                          name="Name"
                          :rules="validationRules.name"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="Name  (English Only)"
                              :error="hasError(errors)"
                            />
                            <input
                              v-model="talent.name"
                              type="text"
                              name="talent[name]"
                              placeholder="Enter your full name"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="phoneNumber"
                          slim="slim"
                          name="Phone No."
                          :rules="validationRules.phoneNumber"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="Phone No."
                              :error="hasError(errors)"
                            />
                            <input
                              v-model="talent.phoneNumber"
                              type="text"
                              name="talent[phone_number]"
                              placeholder="Enter your phone number"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="email"
                          slim="slim"
                          name="Email"
                          :rules="validationRules.email"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label title="Email" :error="hasError(errors)" />
                            <input
                              v-model="talent.email"
                              type="email"
                              name="talent[email]"
                              placeholder="Enter your email"
                              @input="talent.email = talent.email.toLowerCase()"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="birth_date"
                          slim="slim"
                          name="Birth Date"
                          :rules="validationRules.birthDate"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="Birth Date"
                              :error="hasError(errors)"
                            />
                            <DatePicker
                              ref="menu"
                              v-model="talent.birthDate"
                              placeholder="Enter your birth date"
                              name="talent[birth_date]"
                              no-calendar-icon
                              no-header
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="genderId"
                          slim="slim"
                          name="Gender"
                          :rules="validationRules.genderId"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label title="Gender" :error="hasError(errors)" />
                            <div class="radio-checkbox">
                              <sui-form-fields inline>
                                <sui-form-field
                                  v-for="genderOption in genderOptions"
                                  :key="genderOption.value"
                                >
                                  <div class="ui radio checkbox">
                                    <input
                                      :id="genderOption.text"
                                      v-model="talent.genderId"
                                      :value="genderOption.value"
                                      type="radio"
                                      name="talent[gender_id]"
                                    />
                                    <label :for="genderOption.text">
                                      {{ genderOption.text }}
                                    </label>
                                  </div>
                                  <ErrorMessage :message="errors[0]" />
                                </sui-form-field>
                              </sui-form-fields>
                            </div>
                          </sui-form-field>
                        </validation-provider>

                        <LanguageLevels
                          model="talent"
                          :language-options="languageOptions"
                          :level-options="levelOptions"
                          :value="talent.languageLevels"
                        />

                        <validation-provider
                          v-slot="{ errors }"
                          vid="languageSkill"
                          slim="slim"
                          name="Language Certification"
                          :rules="validationRules.languageSkill"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="Language Certification"
                              :error="hasError(errors)"
                            />
                            <textarea
                              v-model="talent.languageSkill"
                              rows="4"
                              name="talent[language_skill]"
                              placeholder="N2, HSK5, TOEIC:800"
                            ></textarea>
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="itSkill"
                          slim="slim"
                          name="PC,It and Programming Skills"
                          :rules="validationRules.itSkill"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="PC,It and Programming Skills"
                              :error="hasError(errors)"
                            />
                            <textarea
                              v-model="talent.itSkill"
                              rows="4"
                              name="talent[it_skill]"
                              placeholder="Enter your technical skills"
                            ></textarea>
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="jobCategory"
                          slim="slim"
                          name="Experienced Job Category"
                          :rules="validationRules.jobCategory"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="Experienced Job Category"
                              :error="hasError(errors)"
                            />
                            <Multiselect
                              v-model="talentJobCategoryIds"
                              :options="jobCategoryOptions"
                              :multiple="true"
                              group-values="children"
                              group-label="textShow"
                              placeholder="Category Search"
                              :group-select="true"
                              track-by="value"
                              label="text"
                              :close-on-select="false"
                              :show-labels="true"
                              :searchable="false"
                            >
                              <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                  <span class="option__small">{{
                                    props.option.$groupLabel
                                  }}</span>
                                </div>
                                <div
                                  v-if="props.option.text"
                                  class="option__desc"
                                >
                                  <span class="option__small">{{
                                    `- ${props.option.text}`
                                  }}</span>
                                </div>
                              </template>
                            </Multiselect>
                            <div v-if="talentJobCategoryIds">
                              <ul>
                                <li
                                  v-for="jobCategory in talentJobCategoryIds"
                                  :key="jobCategory.value"
                                  class="hidden"
                                >
                                  <input
                                    :value="jobCategory.value"
                                    name="talent[talent_potential_candidate_job_categories_attributes][][potential_candidate_job_category_id]"
                                    type="text"
                                  />
                                </li>
                              </ul>
                            </div>
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="jobIndustry"
                          slim="slim"
                          name="Experienced Job Industry"
                          :rules="validationRules.jobIndustry"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="Experienced Job Industry"
                              :error="hasError(errors)"
                            />
                            <Multiselect
                              v-model="talentJobIndustryIds"
                              :options="jobIndustryOptions"
                              :multiple="true"
                              group-values="children"
                              group-label="textShow"
                              placeholder="Industry Search"
                              :group-select="true"
                              track-by="value"
                              label="text"
                              :close-on-select="false"
                              :show-labels="false"
                              :searchable="false"
                            >
                              <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                  <span class="option__small">{{
                                    props.option.$groupLabel
                                  }}</span>
                                </div>
                                <div
                                  v-if="props.option.text"
                                  class="option__desc"
                                >
                                  <span class="option__small">{{
                                    `- ${props.option.text}`
                                  }}</span>
                                </div>
                              </template>
                            </Multiselect>
                            <div v-if="talentJobIndustryIds">
                              <ul>
                                <li
                                  v-for="jobIndustry in talentJobIndustryIds"
                                  :key="jobIndustry.value"
                                  class="hidden"
                                >
                                  <input
                                    :value="jobIndustry.value"
                                    name="talent[talent_potential_candidate_job_industries_attributes][][potential_candidate_job_industry_id]"
                                    type="text"
                                  />
                                </li>
                              </ul>
                            </div>
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="latestSalary"
                          slim="slim"
                          name="Latest Salary"
                          :rules="validationRules.latestSalary"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="Latest Salary"
                              :error="hasError(errors)"
                            />
                            <input
                              v-model="talent.latestSalary"
                              type="number"
                              name="talent[latest_salary]"
                              placeholder="Enter your latest salary"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="latestSalaryPackage"
                          slim="slim"
                          name="Latest Salary Package"
                          :rules="validationRules.latestSalaryPackage"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="Latest Salary Package"
                              :error="hasError(errors)"
                            />
                            <textarea
                              v-if="talent.latestSalaryPackage"
                              v-model="talent.latestSalaryPackage"
                              rows="4"
                              type="text"
                              name="talent[latest_salary_package]"
                              placeholder="Enter your latest salary package"
                            ></textarea>
                            <textarea
                              v-else
                              rows="4"
                              type="text"
                              name="talent[latest_salary_package]"
                              placeholder="Enter your latest salary package"
                            >
Basic Salary: 
Average Incentive: 
Allowance: 
                            </textarea>
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="minSalary"
                          slim="slim"
                          name="Expected Salary (Min)"
                          :rules="validationRules.minSalary"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="Expected Salary (Min)"
                              :error="hasError(errors)"
                            />
                            <input
                              v-model="talent.minSalary"
                              type="number"
                              name="talent[min_salary]"
                              placeholder="Enter your expected salary"
                            />
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="expectedSalaryDetail"
                          slim="slim"
                          name="Expected Salary Detail"
                          :rules="validationRules.expectedSalaryDetail"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="Expected Salary Detail"
                              :error="hasError(errors)"
                            />
                            <textarea
                              v-if="talent.expectedSalaryDetail"
                              v-model="talent.expectedSalaryDetail"
                              rows="4"
                              type="text"
                              name="talent[expected_salary_detail]"
                              placeholder="Enter your expected salary detail"
                            ></textarea>
                            <textarea
                              v-else
                              rows="4"
                              type="text"
                              name="talent[expected_salary_detail]"
                              placeholder="Enter your expected salary detail"
                            >
Basic Salary: 
Average Incentive: 
Allowance: 
                            </textarea>
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="reasonForNewJob"
                          slim="slim"
                          name="Reason For New Job"
                          :rules="validationRules.reasonForNewJob"
                        >
                          <sui-form-field required :error="hasError(errors)">
                            <Label
                              title="Reason for looking for a new job"
                              :error="hasError(errors)"
                            />
                            <textarea
                              v-model="talent.reasonForNewJob"
                              rows="12"
                              type="text"
                              name="talent[reason_for_new_job]"
                              placeholder="Please briefly explain why the candidate is seeking a new opportunity. This may include career advancement, a better match with skills and experience, interest in new challenges, role or compensation changes, company transitions, or personal reasons.

Example:

- Seeking career advancement
- Looking for a role that better matches skills and experience
- Interested in new professional challenges
- Considering a change in role or compensation
- Affected by company transition or restructuring
- Career goals no longer align with the current organization
- Prefer a work location closer to home
- Interested in exploring a different industry

etc."
                            ></textarea>
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          v-slot="{ errors }"
                          vid="memo"
                          slim="slim"
                          name="Skills Memo"
                          :rules="validationRules.memo"
                        >
                          <sui-form-field :error="hasError(errors)">
                            <Label
                              title="Skills Memo"
                              :error="hasError(errors)"
                            />
                            <textarea
                              v-model="talent.memo"
                              rows="4"
                              type="text"
                              name="talent[memo]"
                              placeholder="Enter your skill memo "
                            ></textarea>
                            <ErrorMessage :message="errors[0]" />
                          </sui-form-field>
                        </validation-provider>

                        <validation-provider
                          ref="cachedCvProvider"
                          vid="cachedCv"
                          slim="slim"
                          name="Cached CV"
                        >
                          <input
                            ref="cachedCv"
                            v-model="talent.cachedCvData"
                            type="hidden"
                            name="talent[cv]"
                          />
                        </validation-provider>

                        <validation-provider
                          v-slot="{ validate, errors }"
                          ref="cvProvider"
                          vid="cv"
                          slim="slim"
                          name="CV upload"
                          :rules="cvValidationRule"
                        >
                          <sui-form-field
                            class="upload-button"
                            required
                            :error="hasError(errors)"
                          >
                            <Label
                              title="CV Upload"
                              :error="hasError(errors)"
                            />
                            <InputFile
                              :cached-file-data="talent.cachedCvData"
                              name="talent[cv]"
                              @file-selected="validate"
                            />
                            <ErrorMessage :message="errors[0]" />
                            <div class="note">
                              Only .pdf and less than 10MB files are accepted
                            </div>
                          </sui-form-field>
                        </validation-provider>

                        <SubmitButton :disabled="invalid" label="Confirm">
                        </SubmitButton>
                      </div>
                    </sui-form>
                  </validation-observer>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ApplicationLayoutDefault>
</template>

<script>
import Vue from 'vue'
import SuiVue from 'semantic-ui-vue'
Vue.use(SuiVue)

import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required,
  max,
  regex,
  ext,
  size,
  integer,
} from 'vee-validate/dist/rules'
extend('required', required)
extend('max', max)
extend('regex', regex)
extend('ext', ext)
extend('size', size)
extend('integer', integer)
extend('greaterThanOrEqualTo', {
  params: ['min'],
  validate: (value, { min }) => {
    return value >= min
  },
  message: (field, { min }) => {
    return `${field} must be greater than or equal to ${min}`
  },
})

const validationRules = {
  name: 'required|nameEnglishOnly|max:255',
  phoneNumber: 'required|max:15|regex:^[0-9+]+$',
  email: 'required|emailEnglishNoSpace|max:255',
  birthDate: 'required|max:255',
  genderId: 'required',
  languageSkill: 'max:2000',
  itSkill: 'max:2000',
  minSalary: 'required|integer',
  latestSalary: 'required|integer',
  latestSalaryPackage: 'max:2000',
  expectedSalaryDetail: 'max:2000',
  reasonForNewJob: 'required|max:2000',
  memo: 'max:2000',
  cv: {
    required: 'required|ext:pdf|size:10240',
    validationOnly: 'ext:pdf|size:10240',
  },
}

import ApplicationLayoutDefault from 'components/layouts/Default.vue'
import Form from 'components/ui/form/Form.vue'
import ErrorMessage from 'components/ui/form/ErrorMessage.vue'
import Label from 'components/ui/form/Label.vue'
import InputFile from 'components/ui/form/InputFile.vue'
import LanguageLevels from 'components/ui/form/LanguageLevels.vue'
import SubmitButton from 'components/ui/form/SubmitButton.vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import DatePicker from 'components/ui/form/DatePicker.vue'

import utils from 'mixins/utils'

const ViewProps = window._application.props

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ApplicationLayoutDefault,
    Form,
    ErrorMessage,
    Label,
    InputFile,
    LanguageLevels,
    SubmitButton,
    Multiselect,
    DatePicker,
  },

  mixins: [utils],

  data() {
    const form = ViewProps.talentForm

    return {
      csrfToken: ViewProps.csrfToken,
      validationRules: validationRules,
      talent: form.talent,
      backendErrors: form.errors,
      genderOptions: form.genderOptions,
      languageOptions: form.languageOptions,
      levelOptions: form.levelOptions,
      talentJobIndustryIds: [],
      talentJobCategoryIds: [],
    }
  },

  computed: {
    cvValidationRule: function () {
      if (this.talent.cachedCvData) {
        return this.validationRules.cv.validationOnly
      } else {
        return this.validationRules.cv.required
      }
    },
    jobIndustryOptions() {
      return this.buildOptions(ViewProps.talentForm.jobIndustryOptions)
    },

    jobCategoryOptions() {
      return this.buildOptions(ViewProps.talentForm.jobCategoryOptions)
    },
  },

  created() {
    this.bindJobIndustries()
    this.bindJobCategories()
  },

  mounted: function () {
    this.$refs.form.setErrors(this.backendErrors)
    this.$refs.form.validate({ silent: true })
  },

  methods: {
    buildOptions(options) {
      return options.map((option) => {
        if (option.children.length < 2) {
          option.children.push({
            text: option.text,
            value: option.value,
          })
        }
        return {
          textShow: option.text,
          children: option.children,
        }
      })
    },

    childrenOptions(options) {
      const result = []

      options.forEach((option) => {
        option.children.forEach((child) => {
          result.push(child)
        })
      })

      return result
    },

    bindJobIndustries() {
      const param = this.talent.potentialCandidateJobIndustryIds || ''
      const childrenOptions = this.childrenOptions(this.jobIndustryOptions)

      param.forEach((code) => {
        let targetOption = childrenOptions.find(
          (option) => option.value === parseInt(code)
        )

        if (targetOption) {
          this.talentJobIndustryIds.push(targetOption)
        }
      })
    },

    bindJobCategories() {
      const param = this.talent.potentialCandidateJobCategoryIds || ''
      const childrenOptions = this.childrenOptions(this.jobCategoryOptions)

      param.forEach((code) => {
        let targetOption = childrenOptions.find(
          (option) => option.value === parseInt(code)
        )

        if (targetOption) {
          this.talentJobCategoryIds.push(targetOption)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.main-title {
  @include text-main-title;
}

.register-link {
  margin: 0 auto 2rem auto;
  text-align: center;
  a {
    color: #3742fa;
    display: inline-flex;
    margin-bottom: 1rem;
    padding: 0 15px;
    text-decoration: underline;
    text-underline-offset: 8px;
  }
}

.register-new {
  h3 {
    color: $black;
    font-size: 1.2em;
    margin-bottom: 1.5rem;
  }

  .hidden {
    display: none;
  }

  .range-slider {
    margin-bottom: 1rem;
    width: 80%;

    @include sp {
      width: 100%;
    }

    .text {
      color: $black;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
    .slider-area {
      padding-top: 1.5rem;
      width: 95%;
    }
  }

  .checkbox {
    label {
      cursor: pointer;
    }
  }
}

/* stylelint-disable selector-class-pattern,no-descending-specificity,declaration-no-important */
.error {
  ::v-deep .multiselect__tags {
    background: #fff6f6;
    border-color: #e0b4b4;
    color: #9f3a38;
  }
}

::v-deep .multiselect__tags {
  background: transparent;
  border: 1px solid $black;
  border-radius: 0;
  cursor: pointer;
  display: block;
  min-height: 40px;
  padding: 1rem 1rem;

  input {
    background: transparent !important;
    border: 0 !important;
    &:focus {
      border: 0 !important;
      color: $white !important;
    }
  }
}

::v-deep .multiselect__tag {
  background: #e8e8e8;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 0;

  &-icon {
    &::after {
      color: rgba(0, 0, 0, 0.6);
    }
    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }
  }
}

::v-deep .multiselect__single {
  color: $black;
  font-size: 1em;
  margin: 0.164rem 0;
  padding: 0;
  width: auto;
}

::v-deep .multiselect__select {
  padding-right: 0;
}

::v-deep .multiselect__select::before {
  top: 90% !important;
}

::v-deep .multiselect--active {
  .multiselect__select {
    transform: none !important;
  }
  .multiselect__placeholder {
    display: block !important;
  }
}

::v-deep .multiselect__content-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
}

::v-deep .multiselect__option {
  color: $black;
  font-size: 0.8em;
  white-space: pre-line;
  word-break: break-all;

  &::after {
    display: none;
  }
}

::v-deep .multiselect__option--group {
  background: $white;
  color: $black;

  span.option__small {
    color: $black;
    font-weight: bold;
  }
}

::v-deep .multiselect__option--highlight {
  background: $white;
  color: $black;
}

::v-deep .multiselect__option--group-selected {
  background: gainsboro;
}

::v-deep .multiselect__placeholder {
  color: #b6b7b7;
  font-size: 1em;
  margin: 0.28rem 0;
  padding-top: 0;
}

::v-deep .multiselect__option--selected {
  background: gainsboro;
}

@media screen and (max-width: 991px) {
  ::v-deep .multiselect__tags {
    .multiselect__placeholder {
      font-size: 12px;
    }
  }
}
</style>
